import * as SceneManager from "../../three/sceneManager";
import {render} from "../../three/sceneManager";
import * as Globals from "../../three/globals";
import {layoutView, scenesContainer, sceneView} from "../../three/main";

const border = document.getElementById('moveBorder');
const borderImg = document.getElementById('moveBorderImg');
let fullScreenView = false;

export function attachResizeEvents() {
    window.addEventListener('resize', () => {
        SceneManager.calculateCanvasSizes();
        render();
    });

    let resizeCounter = 0;
    border.addEventListener("mousedown", moveBorder, false);
    borderImg.addEventListener("mousedown", moveBorder, false);
    document.addEventListener("mouseup", function () {
        scenesContainer.removeEventListener("mousemove", resize, false);
    }, false);

    function moveBorder() {
        scenesContainer.addEventListener("mousemove", resize, false);
    }

    function resize(e) {
        resizeCounter++; //Prevent execution on every event fire
        if (resizeCounter < 5) {
            return;
        }
        resizeCounter = 0;

        let screenWidth = scenesContainer.getBoundingClientRect().width;
        let controlsWidth = document.getElementById('sidebar-left').getBoundingClientRect().width;
        let width = e.clientX - controlsWidth;

        if (width < Globals.splitViewportSnapDistance) {
            width = 0;
            fullScreenView = true;
        } else if (width > (screenWidth - Globals.splitViewportSnapDistance)) {
            width = screenWidth - Globals.splitViewportBorderWidth;
            fullScreenView = true;
        } else {
            fullScreenView = false;
        }

        layoutView.style.width = width + "px";
        sceneView.style.width = "calc(100% - " + width + "px - " + Globals.splitViewportBorderWidth + "px)"; //4px border width
        SceneManager.calculateCanvasSizes();
    }
}
